import { BaseEntity } from "./BaseEntity";
import { Internship } from "./Internship";
import { InternshipSchedule } from "./InternshipSchedule";
import { School } from "./School";

export class InternshipScheduleSeat extends BaseEntity {
    public school: string | School = "";
    public noOfSeats: number | undefined = undefined;
    public internship: string | Internship = "";
    public internshipSchedule: string | InternshipSchedule = "";
    public noOfAssignedSeats?: number;

    constructor(model: Partial<InternshipScheduleSeat> = {}) {
        super(model?.id);
        Object.assign(this, model);
    }
}

export type PInternshipScheduleSeat = Partial<InternshipScheduleSeat>;
